/* eslint-disable
    no-return-await, no-console, no-param-reassign, no-trailing-spaces, arrow-body-style
*/
import axios from 'axios';
import moment from 'moment';
import store from '../store';
import helper from '@/_libs/helper';

const ORDER_STATUS = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
  QUOTATION: 9,
};
const SHIPMENT_STATUS = {
  PENDING: 0,
  DELIVERED: 1,
  REJECTED: 2,
};
const BACK_ORDER_STATUS = {
  WAITING: 0,
  READY: 1,
  CANCELLED: 2,
};
const mapOrderStatus = (status) => {
  switch (status) {
    case 'pending_cs':
    case 'pending_admin':
    case 'back_order':
      return ORDER_STATUS.PENDING;
    case 'submitted':
      return ORDER_STATUS.APPROVED;
    case 'cancelled':
      return ORDER_STATUS.REJECTED;
    case 'quotation':
      return ORDER_STATUS.QUOTATION;
    default:
      return -1;
  }
};

const mapCustomer = elm => ({
  ...elm,
  id: elm.id,
  name: elm.name,
  image: elm.image ? elm.image : 'http://placekitten.com/72/72',
  province: elm.province,
  balance: elm.account ? elm.account.remaining_credit : null,
  grade: elm.account ? elm.account.grade : null,
  address: elm.address,
  phone: elm.telephone,
  unpaid: {
    count: elm.account ? elm.account.outstanding_bills_75days : null,
    total: elm.account ? elm.account.outstanding_balance : null,
  },

  zone: elm.area ? elm.area.name : '-',
});

const mapOrder = elm => ({
  ...elm,
  apiStatus: elm.status,

  id: elm.id,
  entryNo: elm.unix_id,
  combinedId: `${elm.unix_id}/${elm.id}`,
  date: elm.updated_at,
  time: elm.updated_at,
  // total: elm.updated_at,
  status: mapOrderStatus(elm.status),
  shipmentStatus: (elm.shipments) ? ((elm.shipments.length === 0) ? 0 : 1) : -1, // eslint-disable-line
  warehouse: ('warehouse_id' in elm && elm.warehouse_id) ? elm.warehouse_id : null,
  products: elm.products,

  customer: elm.customer ? mapCustomer(elm.customer) : undefined,
});


const order = {
  async getNextId(type = 'order') {
    return await helper.call('order.getNextId', {
      next_id: '123456',
    }, async () => await axios(helper.path('orders/nextId'), {
      params: {
        type,
      },
    }));
  },
  async availableWarehouse() {
    return await helper.call('order.warehouseList', [
      {
        value: null,
        text: 'คลังเดิม (ใช้คลังตามเขตลูกค้า)',
      },
      {
        value: 0,
        text: 'MOCK_WAREHOUSE_0',
      },
      {
        value: 1,
        text: 'MOCK_WAREHOUSE_1',
      },
      {
        value: 2,
        text: 'MOCK_WAREHOUSE_2',
      },
    ], async () => {
      const res = await axios(helper.path('orders/getWarehouses'));
      res.data = res.data.map(elm => ({
        value: elm.id,
        text: elm.name,
      }));
      res.data.unshift({
        value: null,
        text: 'คลังเดิม (ใช้คลังตามเขตลูกค้า)',
      });
      return res;
    });
  },
  async availableCarrierForCustomer(customerId) {
    return await helper.call('order.carrierList', {
      success: true,
      data: [
        {
          value: 0,
          text: 'MOCK_CARRIER_1',
        },
        {
          value: 1,
          text: 'MOCK_CARRIER_2',
        },
      ],
    }, async () => {
      const res = await axios(helper.path(`customers/${customerId}/carriers`));
      res.data = res.data.map(elm => ({
        value: elm.id,
        text: elm.name,
      }));
      return res;
    });
  },
  async list(status, page = 1, from, to, filterSearch, filterArea, shipStatus) {
    return await helper.call('sellRecord.sell', {
      success: true,
      data: [],
    }, async () => {
      const res = await axios(helper.path('/api/orders'), {
        params: {
          from: from ? moment(from).format('YYYY-MM-DD HH:mm:ss') : undefined,
          to: to ? moment(to).format('YYYY-MM-DD HH:mm:ss') : undefined,
          'page[number]': page,

          status: (status !== '' && status !== null) ? status : undefined,
          query: !filterSearch ? undefined : filterSearch,
          area: !filterArea ? undefined : filterArea,
          ship_status: (shipStatus === undefined) ? undefined : shipStatus.toString(),
        },
      });

      const ALL_NOTIFICATIONS = store.getters.orderNotifications;
      let ORDERS_WITH_NOTIFICATION = [];
      if (ALL_NOTIFICATIONS) {
        console.log(ALL_NOTIFICATIONS);
        ORDERS_WITH_NOTIFICATION = Object.keys(ALL_NOTIFICATIONS);
      }

      // map everything
      res.data.data = res.data.data.map((elm) => {
        const mappedOrder = mapOrder(elm);

        // should show the notification dot or not
        if (ORDERS_WITH_NOTIFICATION && elm.id) {
          const orderId = elm.id.toString();
          console.log(`${ORDERS_WITH_NOTIFICATION} ${orderId}`);
          console.log(ORDERS_WITH_NOTIFICATION.indexOf(orderId));
          mappedOrder.updated = ORDERS_WITH_NOTIFICATION.includes(orderId);
        }

        // calculate total for each value
        if (elm.products) {
          mappedOrder.total = elm.products.reduce((total, prod) => (total + Number(prod.price)), 0);
        }


        return mappedOrder;
      });

      return res;
    });
  },
  async getReportURL(id) {
    const url = helper.path(`reports/order/${id}`);
    return url;
  },
  async getWithId(id) {
    return await helper.call('order.getDetail', {
      success: true,
      data: [],
    }, async () => {
      const res = await axios(helper.path(`orders/${id}`));

      // grab existing notifications
      const ALL_NOTIFICATIONS = store.getters.orderNotifications;
      const ORDERS_WITH_NOTIFICATION = Object.keys(ALL_NOTIFICATIONS);

      res.data = mapOrder(res.data);

      // should show the notification dot or not
      if (ORDERS_WITH_NOTIFICATION) {
        const orderId = res.data.id.toString();
        // console.log(`${ORDERS_WITH_NOTIFICATION} ${orderId}`);
        // console.log(ORDERS_WITH_NOTIFICATION.indexOf(orderId));
        res.data.updated = ORDERS_WITH_NOTIFICATION.includes(orderId);
      }
      return res;
    });
  },
  async submit(orderDetail) {
    // pre-submit validations
    if (orderDetail.is_quotation !== true) {
      orderDetail.is_quotation = undefined;
    }

    // console.log(orderDetail);
    return await helper.call('order.submit', {
      success: true,
      data: [],
    }, async () => {
      const res = await axios.post(helper.path('orders'), orderDetail);
      return res;
    });
  },
  async update(orderDetail, orderId) {
    // pre-submit validations
    if (orderDetail.is_quotation !== true) {
      orderDetail.is_quotation = undefined;
    }

    // console.log(orderDetail);
    return await helper.call('order.edit', {
      success: true,
      data: [],
    }, async () => {
      const res = await axios.post(helper.path(`orders/${orderId}`), orderDetail);
      return res;
    });
  },
  async removeBackOrderItems(orderId, productIds) {
    return await helper.call('order.cancel', {
      success: true,
      data: [],
    }, async () => {
      const res = await axios.post(helper.path(`orders/${orderId}/removeBackOrderItem`), {
        product_ids: productIds,
      });
      return res;
    });
  },
  async deleteQuotation(orderId) {
    return await helper.call('order.cancel', {
      success: true,
      data: [],
    }, async () => {
      const res = await axios.delete(helper.path(`orders/${orderId}/quotation`));
      return res;
    });
  },

  actions: {
    async approveConditionCheck(orderId) {
      return await helper.call('order.approveConditionCheck', {}, async () => {
        const res = await axios.get(helper.path(`orders/${orderId}/approveConditionCheck`));
        return res;
      });
    },
    async approve(orderId, forceOpen = false) {
      if (forceOpen) {
        return await helper.call('order.approve.forceOpen', {}, async () => {
          const res = await axios.post(helper.path(`orders/${orderId}/approve`), { approve: true, force_open: true });
          return res;
        });
      }
      return await helper.call('order.approve', {}, async () => {
        const res = await axios.post(helper.path(`orders/${orderId}/approve`), { approve: true });
        return res;
      });
    },
    async forward(orderId) {
      return await helper.call('order.forward', {
        success: true,
        status: 201,
        data: [],
      }, async () => {
        const res = await axios.post(helper.path(`orders/${orderId}/forward`));
        return res;
      });
    },
    async reject(orderId) {
      return await helper.call('order.reject', {
        success: true,
        status: 201,
        data: [],
      }, async () => {
        const res = await axios.post(helper.path(`orders/${orderId}/approve`), { approve: false });
        return res;
      });
    },
  },

  ORDER_STATUS,
  SHIPMENT_STATUS,
  BACK_ORDER_STATUS,
  mapOrderStatus,
  mapOrder,
};

export default order;
